import { useState } from "react";
import { Link } from "react-router-dom";
import { Printer, Loader2, BookHeart } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";

export const orderPrintBook = async (tripId) => {
  try {
    const { data } = await api.post(`/trips/${tripId}/print-order`);
    window.open(data.checkout_url, "_blank", "noopener");
    toast.success("Bestelpagina geopend — kies je boekformaat en rond de bestelling af bij Peecho", { duration: 8000 });
  } catch (err) {
    const d = err.response?.data?.detail;
    toast.error(typeof d === "string" ? d : "Bestellen mislukt — probeer het zo opnieuw", { duration: 8000 });
  }
};

export const PrintOrderButton = ({ tripId, variant = "button" }) => {
  const [busy, setBusy] = useState(false);

  const order = async () => {
    setBusy(true);
    try {
      await orderPrintBook(tripId);
    } finally {
      setBusy(false);
    }
  };

  if (variant === "card") {
    return (
      <div className="bg-card rounded-2xl p-5 mb-4 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="print-order-card">
        <span className="w-10 h-10 rounded-full bg-[#B5838D] flex items-center justify-center shrink-0">
          <BookHeart className="w-5 h-5 text-white" />
        </span>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-sm">Jouw trip als gedrukt fotoboek</h3>
          <p className="text-xs text-muted-foreground mt-0.5">
            Laat je reisverslag drukken en thuisbezorgen via Peecho.{" "}
            <Link to={`/trip/${tripId}/fotoboek`} data-testid="print-order-edit-link" className="text-primary font-semibold hover:underline">Eerst bewerken of bekijken?</Link>
          </p>
        </div>
        <Button data-testid="print-order-button-card" onClick={order} disabled={busy}
          className="rounded-full bg-[#B5838D] hover:bg-[#9c6d78] active:scale-95 transition-[transform,background-color] duration-200 shrink-0">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Printer className="w-4 h-4 mr-1.5" />}
          Bestel als boek
        </Button>
      </div>
    );
  }

  return (
    <Button data-testid={variant === "bottom" ? "print-order-button-bottom" : "print-order-button"} onClick={order} disabled={busy}
      className="rounded-full bg-[#B5838D] hover:bg-[#9c6d78] active:scale-95 transition-[transform,background-color] duration-200">
      {busy ? <Loader2 className="w-4 h-4 animate-spin sm:mr-1.5" /> : <Printer className="w-4 h-4 sm:mr-1.5" />}
      <span className="hidden sm:inline">Bestel als boek</span>
    </Button>
  );
};
